import React from 'react';
import { Form, Formik } from 'formik';
import DocumentsToAcceptFormSubmitButton from './DocumentsToAcceptFormSubmitButton';
import { Accordion } from 'primereact/accordion';
import {
  buildDocumentsToAcceptInitialValues,
  buildDocumentsToAcceptValidationSchema,
  buildDocumentTabs,
} from '../../helpers/dashboard.helper';

const DocumentsToAcceptForm = ({ handleSubmit, pendingChangeRequests }) => {
  const initialValues = buildDocumentsToAcceptInitialValues();
  const validationSchema = buildDocumentsToAcceptValidationSchema(pendingChangeRequests);
  const documentTabs = buildDocumentTabs(pendingChangeRequests);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => handleSubmit(values)}
    >
      {() => (
        <Form className="text-black">
          <Accordion key={pendingChangeRequests.length} multiple activeIndex={[0]}>
            {documentTabs}
          </Accordion>
          <br />
          <DocumentsToAcceptFormSubmitButton />
        </Form>
      )}
    </Formik>
  );
};

export default DocumentsToAcceptForm;
